export default {
  // API_ENDPOINT: 'http://localhost:8000/api',
  API_ENDPOINT: 'https://limitless-brushlands-45977.herokuapp.com/api',
  // IMAGES_ENDPOINT: 'http://localhost:8000/images',
  IMAGES_ENDPOINT: 'https://limitless-brushlands-45977.herokuapp.com/images',
  TOKEN_KEY: 'super-secret-secret'
}